<script>
import { ChiRhosNext } from '@paladin/core'

// import { AuthHelpers } from '@paladin/core-auth'
// import { PaladinCoreStateHelpers } from '@paladin/core'
import {
  PersonConstruct,
  CommunicationSettings,
  CommunicationOptions,
} from '@chirhos/chirhos-api'
import Vue from 'vue'
import { PaladinMetaProperties } from '@paladin/core-components'
import _ from 'lodash'

const ChiRhosNextApi = new ChiRhosNext().api()

export default {
  components: { PaladinMetaProperties },
  props: {
    identity: {
      type: Object,
      required: true,
    },
    user: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      presets: null,
      form: {
        inviteCode: '',
        // profileImage: '',
        genderType: '',
        email: '',
        alternativeEmail: '',
        firstName: '',
        middleName: '',
        knownAs: '',
        lastName: '',
        alternativeLastName: '',
        mobilePhone: '',
        alternativePhone: '',
        dateOfBirth: '',
        communicationSettings: {
          marketing: {
            email: false,
            sms: false,
            whatsApp: false,
          },
          notifications: {
            email: false,
            sms: false,
            whatsApp: false,
          },
        },
        properties: {},
        integration: {},
      },
      genderTypes: [
        { text: 'Select', value: null },
        { text: 'Male', value: 'M' },
        { text: 'Female', value: 'F' },
        { text: 'Other', value: 'O' },
      ],
      panel: 'default',
      profileLoaded: false,
    }
  },
  computed: {
    // ...AuthHelpers.authComputed,
    // ...PaladinCoreStateHelpers.userComputed,
  },
  watch: {
    user: {
      handler: function() {
        this.init()
      },
      deep: true,
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.init()
    })
  },
  methods: {
    init() {
      // let presets = this.presets
      let initProfile = this.initProfile

      if (!this.presets) {
        ChiRhosNextApi.TenantApi.get().then(
          (response) => {
            if (response.data && response.data.entity) {
              this.presets = response.data.entity.personPropertyPresets

              initProfile()
            }
          },
          (error) => {
            console.error(error)
          }
        )
      } else {
        initProfile()
      }
    },
    initProfile() {
      var _profile = {
        // profileImage: '',
        genderType: '',
        email: '',
        alternativeEmail: '',
        firstName: '',
        middleName: '',
        knownAs: '',
        lastName: '',
        alternativeLastName: '',
        mobilePhone: '',
        alternativePhone: '',
        dateOfBirth: '',
        communicationSettings: {
          marketing: {
            email: false,
            sms: false,
            whatsApp: false,
          },
          notifications: {
            email: false,
            sms: false,
            whatsApp: false,
          },
        },
        properties: {},
        integration: {},
      }

      if (this.user && this.user.profile) {
        _profile.genderType =
          this.user.profile.genderType || this.identity.profile.gender
        _profile.alternativeEmail = this.user.profile.alternativeEmail
        _profile.email = this.user.profile.email || this.identity.profile.email
        _profile.firstName =
          this.user.profile.firstName || this.identity.profile.given_name
        _profile.middleName = this.user.profile.middleName
        _profile.knownAs = this.user.profile.knownAs
        _profile.lastName =
          this.user.profile.lastName || this.identity.profile.family_name
        _profile.alternativeLastName = this.user.profile.alternativeLastName
        _profile.mobilePhone = this.user.profile.mobilePhone
        _profile.alternativePhone = this.user.profile.alternativePhone
        _profile.dateOfBirth = this.user.profile.dateOfBirth
          ? new Date(this.user.profile.dateOfBirth).toISOString().slice(0, 10)
          : ''

        if (this.user.profile.communicationSettings)
          _profile.communicationSettings = _.cloneDeep(
            this.user.profile.communicationSettings
          )

        if (this.user.profile.properties) {
          _profile.properties = _.cloneDeep(this.user.profile.properties)
        }

        if (this.user.profile.integration)
          _profile.integration = _.cloneDeep(this.user.profile.integration)
      } else {
        _profile.genderType = this.identity.profile.gender
        _profile.email = this.identity.profile.email
        _profile.firstName = this.identity.profile.given_name
        _profile.lastName = this.identity.profile.family_name

        this.panel = 'lookup'
      }

      this.form = _profile
    },
    createNew() {
      this.panel = 'default'
    },
    goLookup(evt) {
      evt.preventDefault()

      if (!this.form.email && !this.form.mobilePhone) {
        this.$toast('You must provide email address or phone number', 'error')
      } else {
        // we can lookup

        ChiRhosNextApi.PersonApi.inviteAllMatching({
          email: this.form.email,
          phone: this.form.mobilePhone,
        }).then(
          (response) => {
            if (response.data === 0) {
              this.$toast('No matching profiles', 'warning')
              this.panel = 'default'
            } else {
              this.$toast('Invite code(s) sent!', 'success')
              this.panel = 'link'
            }
          },
          (error) => {
            console.error(error)
            error.json().then((body) => {
              this.$toast(body.Message, 'error')
            })
          }
        )
      }
    },
    link(evt) {
      evt.preventDefault()

      if (!this.form.inviteCode) {
        this.$toast('You must provide the invite code', 'error')
      } else {
        // we can try to link

        ChiRhosNextApi.PersonApi.acceptInvite(
          this.form.inviteCode.trim().toUpperCase()
        ).then(
          (response) => {
            this.$toast('Profile linked!', 'success')

            this.$store.dispatch('user/getProfile').then(
              (response) => {
                this.$toast('Profile loaded', 'success')
                this.panel = 'default'
              },
              (error) => {
                this.$toast(error, 'error')
              }
            )
          },
          (error) => {
            console.error(error)
            error.json().then((body) => {
              this.$toast(body.Message, 'error')
            })
          }
        )
      }
    },
    onSubmit(evt) {
      evt.preventDefault()
      // alert(JSON.stringify(this.form))

      var _personModel = new PersonConstruct(
        this.form.genderType,
        this.form.firstName,
        this.form.lastName
      )

      _personModel.entityId =
        this.user && this.user.profile ? this.user.profile.entityId : undefined

      _personModel.middleName = this.form.middleName
      _personModel.knownAs = this.form.knownAs
      _personModel.alternativeLastName = this.form.alternativeLastName
      _personModel.mobilePhone = this.form.mobilePhone
      _personModel.alternativePhone = this.form.alternativePhone
      _personModel.email = this.form.email
      _personModel.alternativeEmail = this.form.alternativeEmail
      _personModel.dateOfBirth = this.form.dateOfBirth
      _personModel.properties = this.form.properties
      _personModel.integration = this.form.integration

      // _personModel.memberOfGroup = this.form.memberOfGroup
      // _personModel.memberOfGroupType = this.form.memberOfGroupType
      // _personModel.creatorPersonEntityId = this.form.creatorPersonEntityId
      // _personModel.properties = this.form.properties

      _personModel.communicationSettings = new CommunicationSettings(
        new CommunicationOptions(
          this.form.communicationSettings.notifications.email,
          this.form.communicationSettings.notifications.sms
        ), // notifications
        new CommunicationOptions(
          this.form.communicationSettings.marketing.email,
          this.form.communicationSettings.marketing.sms
        ) // marketing
      )

      this.$store
        .dispatch(
          'user/saveProfile',
          {
            value: _personModel,
          },
          { root: true }
        )
        .then(
          (response) => {
            this.$toast('Person successfully saved', 'success')
          },
          (error) => {
            this.$toast(error, 'error')
          }
        )
    },
    onReset(evt) {
      evt.preventDefault()
      /* Reset our form values */
      this.form.email = ''
      this.form.name = ''
      this.form.lastName = null
      /* Trick to reset/clear native browser form validation state */
      this.panel = ''
      this.$nextTick(() => {
        this.panel = 'default'
      })
    },
    setMetaValue(ev) {
      Vue.set(this.form.properties, ev.key, ev.value)
    },
  },
}
</script>

<template src="./profile.html"></template>
